import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { customPalette } from '../../../styles/theme';

export const MobileMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${customPalette.accent.main};
  position: fixed;
  top: 120px;
  right: 0;
  width: 100%;
  height: calc(100% - 120px);
  z-index: 1000;
  color: ${customPalette.accent.white};
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
`;

export const MenuItem = styled(Link)<{ active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  text-decoration: none;
  color: ${({ active }) =>
    active ? customPalette.accent.white : customPalette.grey[200]};
  font-size: 18px;

  & > div {
    margin-right: 16px;
  }

  &:hover {
    color: ${customPalette.accent.white};
  }
`;

export const IconContainer = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${({ active }) =>
    active ? customPalette.accent.defaultGreen : 'transparent'};
`;

export const UserProfile = styled(MenuItem)`
  margin-top: auto;
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  width: 100%;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  text-align: left;
  color: ${customPalette.grey[200]};

  & > div {
    margin-right: 16px;
  }

  &:hover {
    color: ${customPalette.accent.white};
  }
`;

export const BPNumber = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};
`;
